import { Mui, MuiIcons } from "@osu/react-ui";

const FORCED_AUTHENTICATION = process.env.REACT_APP_FORCED_AUTHENTICATION === "true"
const OSU_NAV_ID = 'osu-navbar'
const MAIN_ID = 'page-content'
const ACCESSIBLE_REFLOW_HEIGHT = `399px`
const TOC_WIDTH = `15rem`
const NAVBAR_WRAPPER_ID = "app-header"
const APPLICATION_NAME = (process.env.APPLICATION_NAME) || "Honors & Scholars";

const DARK_MODE_CLASSNAME = 'dark-mode-enabled'

// Dark mode constants
const THEME_CACHE_KEYS = {
  darkMode: "darkMode",
  system: "system",
  dark: "dark",
  light: "light"
};

const CONFIG_VIEW = {
  RUBRIC_VIEW: 'RUBRIC_VIEW',
  CRITERIA_VIEW: 'CRITERIA_VIEW',
}

const CACHE_OPTIONS = {
  [THEME_CACHE_KEYS.darkMode]: {
    [THEME_CACHE_KEYS.system]: "Use system settings",
    [THEME_CACHE_KEYS.dark]: "Dark",
    [THEME_CACHE_KEYS.light]: "Light"
  }
};

const TOOLTIP_STATUS = {
  ASSIGNED: "ASSIGNED",
  PRIORITY: "PRIORITY",
  RESUMELATER: "RESUMELATER",
  TRAINING: "TRAINING",
  PASTDUE: "PASTDUE",
  HOLD_FOR_ADMIN: "HOLD_FOR_ADMIN",
  CURRENTLY_VIEWING: "CURRENTLY_VIEWING",
}

const SUCCESS_API_ENDPOINT_WHITELIST = {
  ARCHIVE_RUBRIC: "archiveRubric",
  CLONE_RUBRIC: "cloneRubric",
  CREATE_RUBRIC: "createARubric",
  DELETE_RUBRIC: "deleteRubric",
  SAVE_RUBRIC: "saveRubricV2",
  SET_ACTIVE_RUBRIC: "setActiveRubric",
}

const ERROR_API_ENDPOINT_BLACKLIST = {
  APPLICATION_RESTART_REVIEW: "applicationRestartReview",
  APPLICATION_ASSIGN_REVIEW: "applicationAssignReview",
  APPLICATION_REASSIGN_REVIEW: "applicationReassignReview",
  APPLICATION_UNASSIGN_REVIEW: "applicationUnassignReview",
  APPLICATION_SUBMIT_REVIEW: "applicationSubmitReview",
}

const ACTION_TYPES = {
  QUERY_FULFILLED: 'graphqlApi/executeQuery/fulfilled',
  QUERY_REJECTED: 'graphqlApi/executeQuery/rejected',
  MUTATION_FULFILLED: 'graphqlApi/executeMutation/fulfilled',
  MUTATION_REJECTED: 'graphqlApi/executeMutation/rejected',
};

const STATUSES = {
  IDLE: "idle",
  LOADING: "loading",
  ERROR: "error",
  SUCCESS: "success",
  CLEARED: "cleared",
  UNAUTH: "unauth",
  WARNING: "warning",
  COGNITO_FAILURE: "COGNITO_FAILURE",
}

const TOOLTIPS = (type, data) => {
  const iconStyles = {
    margin: '.1rem 0 0 .3rem'
  }

  switch (type) {
    case TOOLTIP_STATUS.ASSIGNED:
      return (
        <Mui.Tooltip title={"This application has been manually assigned."} placement="right">
          <MuiIcons.AssignmentLate fontSize="small" style={{ color: '#ffbe45', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.PRIORITY:
      return (
        <Mui.Tooltip title={"This application has been marked as a priority."} placement="right">
          <MuiIcons.AssignmentLate fontSize="small" color='primary' style={{ ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.RESUMELATER:
      return (
        <Mui.Tooltip title={"This application has been saved for later."} placement="right">
          <MuiIcons.Bookmark fontSize="small" style={{ color: '#639ed6', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.TRAINING:
      return (
        <Mui.Tooltip title={"This application has been cloned for training."} placement="right">
          <MuiIcons.School fontSize="small" style={{ color: '#ffbe45', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.PASTDUE:
      return (
        <Mui.Tooltip title={"This application is past due."} placement="right">
          <MuiIcons.AccessAlarm fontSize="small" style={{ color: '#f72d05', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.HOLD_FOR_ADMIN:
      return (
        <Mui.Tooltip title={`Held since ${data}`} placement="right">
          <MuiIcons.Policy fontSize="small" style={{ color: '#a8224a', ...iconStyles }} />
        </Mui.Tooltip>
      )
    case TOOLTIP_STATUS.CURRENTLY_VIEWING:
      return (
        <Mui.Tooltip title={"Currently Viewing"} placement="top">
          <MuiIcons.Circle className={'margin-left-1'} color='primary' sx={{ fontSize: 10 }} />
        </Mui.Tooltip>
      )

    default:
      return null
  }
}

const PROGRAMS = {
  HONORS: { KEY: "honors", label: 'Honors' },
  SCHOLARS: { KEY: "scholars", label: 'Scholars' },
}

const PROGRAM_COLOR_MAP = {
  "honors": "#00CCFF",
  "scholars": "#CCCCFF",

};


const DASHBOARD_BUTTON_GROUP = {
  SAVED: { KEY: "SAVED", LABEL: 'Saved', TYPE: 'TOGGLE_SAVED', ARIA_LABEL: "saved" },
  ASSIGNED: { KEY: "ASSIGNED", LABEL: 'Assigned', TYPE: 'TOGGLE_ASSIGNED', ARIA_LABEL: "assigned" },
};

const AUTH_ROLES = {
  // Generic
  ADMIN_ACCESS: "ADMIN-ACCESS",
  READ_ACCESS: "READ-ACCESS",

  // Program-specific
  HONORS_ADMIN: "HONORS-ADMIN",
  SCHOLARS_ADMIN: "SCHOLARS-ADMIN",
  STUDENT_EMPLOYEE: "STUDENT-EMPLOYEE",

  //   // TODO Delete:
  //   ADMIN: "ADMIN",
  //   READER: "READER", // todo: remove reader
  //   REVIEWER: "REVIEWER",
  //   UNAUTHORIZED: "UNAUTHORIZED",
  //   ADMIN_REVIEWER: "ADMIN_REVIEWER"
}

const STATUS_BOOLEAN = {
  YES: 'Yes',
  NO: 'No',
}

const SEVERITY_LEVELS = {
  INFO: 'INFO',
  SUCCESS: 'SUCCESS',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
}

const ERROR_CONSTS = {
  UI: {
    GENERIC: {
      EMPTY_ALERT: {
        MESSAGE: '',
        SEVERITY: null,
      },
    },
  },
};

const ALERT_MESSAGES = {
  ERROR_GENERIC:
    'Error retreiving data.',
};

const API_STATUS = {
  LOADING: "LOADING",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS"
}

const AUTH_STATUS = {
  CLEARED: "cleared",
  COGNITO_FAILURE: "COGNITO_FAILURE",
  IDLE: "idle",
  LOADING: "loading",
}


export {
  ACCESSIBLE_REFLOW_HEIGHT, ALERT_MESSAGES, API_STATUS, APPLICATION_NAME,
  AUTH_STATUS, AUTH_ROLES,
  PROGRAM_COLOR_MAP, DASHBOARD_BUTTON_GROUP, PROGRAMS,
  DARK_MODE_CLASSNAME, THEME_CACHE_KEYS, CACHE_OPTIONS,
  ERROR_CONSTS, FORCED_AUTHENTICATION, MAIN_ID, NAVBAR_WRAPPER_ID,
  OSU_NAV_ID, 
  SEVERITY_LEVELS,
  STATUS_BOOLEAN, TOOLTIP_STATUS, TOC_WIDTH, 
  TOOLTIPS,
  SUCCESS_API_ENDPOINT_WHITELIST, ERROR_API_ENDPOINT_BLACKLIST,
  STATUSES, ACTION_TYPES, CONFIG_VIEW
};